import React, { useRef } from "react";
import axios from "axios";
import CanvasDraw from "react-canvas-draw";
import Button from "../../common/Button";

const Notepad = ( props ) => {

  const canvasDraw = useRef();

  const onNotes = ( target ) => {
    const strokes = {
      x : target.lines.map( v => v.points.map( v => v.x ) ),
      y : target.lines.map( v => v.points.map( v => v.y ) )
    };
    if ( target.lines.length ) {
      const success = ( response ) => {
        props.onNotes( response.data.ocrresult.latex_styled );
      };
      axios.post( `${ process.env.REACT_APP_OCR_API_URL }/api/upload_etc`, { strokes : { strokes } } ).then( success );
    } else {
      props.onClear( Date.now() );
    }
  };

  const onUndo = () => {
    canvasDraw.current.undo();
  };

  const onClear = () => {
    canvasDraw.current.clear();
    props.onClear( Date.now() );
  };

  return (
    <div style={ { width : '60%' } }>
      <CanvasDraw
        style={ { border : '1px solid' } }
        ref={ canvasDraw }
        canvasWidth="100%"
        canvasHeight="500px"
        hideInterface={ true }
        lazyRadius={ 0 }
        brushRadius={ 3 }
        onChange={ onNotes }
      />
      <div style={ { height : 5 } } />
      <Button className="btn btn-red" style={ { width : 80 } } onClick={ onUndo }>Undo</Button>
      <span style={ { padding : 2.5 } } />
      <Button className="btn btn-red" style={ { width : 80 } } onClick={ onClear }>Clear</Button>
    </div>
  );

};

export default Notepad;
